<template>
    <div>
        <div class="companiesOrder">
            <div class="companyOrder" v-for="(company, index) in companies">
                <div class="row">
                    <div class="col-md-5">
                        <div class="form-group">
                            <label :for="'companies[' + index + '][name]'">
                                <slot name="name-label"></slot>
                            </label>
                            <input type="text" :name="'companies[' + index + '][name]'" v-model="company.name"  @keydown.enter.prevent>
                        </div>
                    </div>

                    <div class="col-md-5">
                        <div class="form-group">
                            <label :for="'companies[' + index + '][email]'">
                                <slot name="email-label"></slot>
                            </label>
                            <input type="text" :name="'companies[' + index + '][email]'" v-model="company.email"  @keydown.enter.prevent>
                        </div>
                    </div>

                    <div class="col-md-2 companyOrder__actions">
                        <button type="button" class="btn-medium-grey companyOrder__delete" @click="deleteCompany(index)">
                            <slot name="delete-label"></slot>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button type="button" class="btn-blue" @click="addCompany">
                <slot name="add-label"></slot>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            oldCompanies: {
                name: String,
                email: String,
                default: () => [
                    {
                        name: '',
                        email: ''
                    }
                ]
            }
        },
        data() {
            return {
                companies: this.oldCompanies
            }
        },
        methods: {
            addCompany() {
                this.companies.push({
                    name: '',
                    email: ''
                });
            },
            deleteCompany(index) {
                this.companies.splice(index, 1);
                if (this.companies.length === 0) {
                    this.addCompany();
                }
            }
        }
    }
</script>
